import React from "react";
import { StyleSheet, Text, TextInput, View } from "react-native";
import { Feather } from "@expo/vector-icons";

import { CORES, sombraCard } from "./styles";

// Campo de formulário do layout novo: rótulo em cima, caixa branca com ícone
// (ou prefixo, ex.: +55) e texto de ajuda opcional embaixo.

interface Props {
  rotulo: string;
  valor: string;
  onChangeText: (text: string) => void;
  corPrincipal: string;
  icone?: string;
  prefixo?: string;
  placeholder?: string;
  ajuda?: string;
  senha?: boolean;
  numerico?: boolean;
  maxLength?: number;
  destaque?: boolean; // borda na cor principal
  estiloInput?: any;
}

export default function Campo({
  rotulo,
  valor,
  onChangeText,
  corPrincipal,
  icone,
  prefixo,
  placeholder,
  ajuda,
  senha,
  numerico,
  maxLength,
  destaque,
  estiloInput,
}: Props) {
  return (
    <View style={styles.campo}>
      <Text style={styles.rotulo}>{rotulo}</Text>

      <View
        style={[
          styles.caixa,
          sombraCard,
          destaque && { borderColor: corPrincipal },
        ]}
      >
        {!!prefixo && (
          <View style={[styles.prefixo, destaque && { borderRightColor: corPrincipal }]}>
            <Text style={[styles.textoPrefixo, { color: corPrincipal }]}>
              {prefixo}
            </Text>
          </View>
        )}

        {!prefixo && !!icone && (
          <View style={styles.icone}>
            <Feather name={icone as any} size={17} color={corPrincipal} />
          </View>
        )}

        <TextInput
          value={valor}
          onChangeText={onChangeText}
          placeholder={placeholder}
          placeholderTextColor="#b5b0a6"
          secureTextEntry={senha}
          keyboardType={numerico ? "numeric" : "default"}
          maxLength={maxLength}
          style={[styles.input, estiloInput] as any}
        />
      </View>

      {!!ajuda && <Text style={styles.ajuda}>{ajuda}</Text>}
    </View>
  );
}

const styles = StyleSheet.create({
  campo: {
    marginBottom: 14,
  },
  rotulo: {
    fontSize: 13,
    fontWeight: "700",
    color: CORES.titulo,
    marginBottom: 8,
  },
  caixa: {
    flexDirection: "row",
    alignItems: "center",
    height: 52,
    borderRadius: 14,
    backgroundColor: CORES.card,
    borderWidth: 1,
    borderColor: CORES.borda,
    overflow: "hidden",
  },
  prefixo: {
    height: "100%",
    paddingHorizontal: 14,
    justifyContent: "center",
    backgroundColor: "#F7F4EE",
    borderRightWidth: 1,
    borderRightColor: CORES.borda,
  },
  textoPrefixo: {
    fontSize: 15,
    fontWeight: "700",
  },
  icone: {
    paddingLeft: 16,
  },
  input: {
    flex: 1,
    height: "100%",
    paddingHorizontal: 12,
    fontSize: 16,
    color: CORES.titulo,
    outlineStyle: "none",
  },
  ajuda: {
    fontSize: 12,
    color: CORES.subtitulo,
    marginTop: 6,
  },
});
